import React from 'react';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import EditUserPage from './EditUserPage';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import { escalationLevelOptions } from '../constant';
import { cloneDeep, isEqual } from 'lodash';
import helper from '../../../../../utils/helper';
import lookupActions from '../../../../../actions/lookup.actions';
import { bindActionCreators } from 'redux';

class EditUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      originalUsername: null,
      getUserError: {},
      departments: [],
      roles: [],
      groups: [],
      isSubmitting: false,
      loading: false,
      errors: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (!isEqual(nextProps.configure.user, prevState.user)) {
      state.user = Object.assign({}, nextProps.configure.user);
      state.originalUsername = nextProps.configure.user.userName;
    }
    if (nextProps.configure.getUserError !== prevState.getUserError) {
      state.getUserError = nextProps.configure.getUserError;
    }
    if (nextProps.lookup.roles !== prevState.roles) {
      state.roles = nextProps.lookup.roles;
    }
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.lookup.groups !== prevState.groups) {
      state.groups = nextProps.lookup.groups;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    await this.props.configureActions.getSpecificUser(id);
    await this.props.lookupActions.getDepartmentsWithoutGlobal();
    await this.props.lookupActions.getRoles();
    await this.props.lookupActions.getGroups();
  }

  onEditUser = (params) => {
    const { id } = this.props.match.params;
    const _params = Object.assign({}, params);
    _params.roleNames = [params.roleNames];
    this.props.configureActions
      .editUser(id, _params)
      .then(() => this.props.history.push('/configure/users'))
      .catch((err) => console.log(err));
  };

  // isEditable() {
  //   const roleNames =
  //     JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
  //   const isAdmin = roleNames.includes('admin') || roleNames.includes('Admin');
  //   if (isAdmin) {
  //     return false;
  //   }
  //   const loggedInGroupIds =
  //     JSON.parse(localStorage.getItem('userProfile')).groupIdArray || [];
  //   const editingUserGroupsIds = this.state.user.groupIdArray || [];
  //   const intersection = loggedInGroupIds.filter((element) =>
  //     editingUserGroupsIds.includes(element),
  //   );
  //   return intersection.length ? false : true;
  // }

  render() {
    //prettier-ignore
    const { loading, user, getUserError, isSubmitting, errors, departments, roles, groups } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    const _user = Object.assign({}, user);
    if (Object.keys(_user).length) {
      if (user.active) {
        _user.activeText = 'Active';
      } else {
        _user.activeText = 'Inactive';
      }
      _user.workDaysOfWeek = user.workDaysOfWeek
        ? user.workDaysOfWeek.split(',').map((w) => w.trim())
        : [];
      if (typeof _user.startWork === 'string') {
        const t = _user.startWork.split(':');
        _user.startWork = new Date().setHours(t[0], t[1]);
      }
      if (typeof _user.endWork === 'string') {
        const t = _user.endWork.split(':');
        _user.endWork = new Date().setHours(t[0], t[1]);
      }
      _user.escalationLevelText = escalationLevelOptions.filter(
        (es) => es.value === user.escalationLevel,
      )[0].label;
      const { deptName, deptId } = helper.getUserDepartment(departments);
      const roleNames = cloneDeep(user.roleNames)[0];
      _user.roleNames = roleNames;
    }
    return (
      <EditUserPage
        user={_user}
        originalUsername={this.state.originalUsername}
        getUserError={getUserError}
        onEditUser={this.onEditUser}
        isSubmitting={isSubmitting}
        errors={errors}
        departments={departments}
        roles={roles}
        groups={groups}
        // isEditable={this.isEditable()}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
